/**
 * @author A_Sir 2017-11-27
 * 用户模块
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {Http,Headers} from "@angular/http";
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {Router} from "@angular/router";
import {Cookie} from "ng2-cookies/ng2-cookies";

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {
  nav:any[] =  [
    {
      "bar": "首页",
      "id": "firPage",
      "path":"servicepage"
    },
    {
      "bar": "企业信息",
      "id": "firmCen",
      "path":"servicepage/firm"
    },
    {
      "bar": "采购中心",
      "id": "buyCen",
      "path":"servicepage/purchase"
    },
    {
      "bar": "合同中心",
      "id": "contractCen",
      "path":"servicepage/contract"
    },
    {
      "bar": "统计查询",
      "id": "dataCen",
      "path":"servicepage/statistics"
    },
    {
      "bar": "联系我们",
      "id": "conCen",
      "path":"servicepage/connectus"
    }
  ];
  username:string=null;
  token:string = null;
  index:number=0;
  is_getmes:boolean = false;
  private headers= new Headers({'Content-Type': 'application/json'});
  private options;
  constructor( private router:Router,
               private http:Http)
  {}
  ngOnInit() {
    if(Cookie.get("index")==undefined){
      this.index=0;
      this.routeUrl('servicepage',0);
    }else{
      var i = Cookie.get("index");
      this.index = parseInt(i);
    }
    this.username = Cookie.get("username");
    this.token = Cookie.get("usertoken");
  }
  ngDoCheck(){
    this.index = parseInt(Cookie.get("index"));
  }
  ngAfterViewInit(){}
  //链接跳转
  routeUrl(path,i){
    if(i == 2||i==3||i==4){
      var bool = this.checkInvoice();
      if(bool==true){//有信息
        this.index = i;
        Cookie.delete("index");
        Cookie.set("index",i.toString());
        this.router.navigate([""+path+""]);
      }else{//没有信息出现提示
        this.is_getmes= true;
      }
    }else{
      this.index = i;
      Cookie.delete("index");
      Cookie.set("index",i.toString());
      this.router.navigate([""+path+""]);
    }
  }
  //检测是否填写信息
  checkInvoice(){
    var infor =  Cookie.get("infor");
    if(infor =="notok"){
      return false;
    }else if(infor=="ok"){
      return true;
    }
  }
  getmesTip(){//获取信息提示
    this.is_getmes = false;
    Cookie.delete("index");
    Cookie.set("index","1");
    this.router.navigate(['servicepage/firm']);
  }
}



// WEBPACK FOOTER //
// ./src/mainpage/customer/customer.component.ts